/* ============================================================================
   FRONT LINE DEV - DO NOT EDIT
   This file powers Infinit's custom Quiz and Custom Formula functionality and
   is maintained exclusively by Front Line Dev. Editing it may break the
   formula builder, quiz, saved formulas, or related features. Please contact
   Front Line Dev for any changes.
   ============================================================================ */

/**
 * Quiz Test Harness
 *
 * Activated via ?test=yes on the quiz page.
 * Injects preset test-scenario buttons on the intro panel.
 * Each button calls QuizEngine.fetchAndScore() with a fixture,
 * renders results into the existing quiz-results-inline DOM,
 * and appends diagnostic output.
 */
(function () {
  'use strict';

  // ── Gate: only run when ?test=yes ──────────────────────────────────
  if (!/[?&]test=yes/i.test(window.location.search)) return;

  // ── Test Fixtures ──────────────────────────────────────────────────

  var FIXTURES = [
    {
      name: '1. Basic Runner (1 hr)',
      description: 'Half-marathon runner, moderate settings, no edge cases. Verifies: single hydration + protein, event-named formula, morning JAVI/COLD BREW rec.',
      answers: {
        'customer[first_name]': 'TestRunner',
        q1_sport_focus: 'running',
        q1_running_primary_event: 'Half Marathon',
        q1_running_type: ['road_running'],
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['gels', 'drink_mix'],
        q4_athlete_level: 50,
        q5_sweat_level: 50,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 50,
        q8_cramp_frequency: 25,
        q9_birth_date: '1990-06-15',
        q10_weight_lbs: 170,
        q11_sex: 'male',
        q12_body_fat_category: '15_25',
        q15_region: 'midwest',
        q16_workout_location: 'outside',
        q17_flavor_strength: 50,
        q18_flavor_vibe: 'fruit_berry',
        q19_caffeine_pref: 'moderate',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 50,
        q26_soreness: 50,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '2. Ultra Endurance (3+ hr)',
      description: 'Ultra-marathon runner, starving hunger. Verifies: dual hydration formulas, hunger->ultra override (ps=20, aa=20 instead of 40), Short/Long Mix naming.',
      answers: {
        'customer[first_name]': 'UltraTest',
        q1_sport_focus: 'running',
        q1_running_primary_event: 'Ultra Marathon',
        q1_running_type: ['ultra_marathon'],
        q2_workout_length: '3_plus_hours',
        q2_hunger: 100,
        q3_fueling_habits: ['gels', 'real_food', 'salt_pills'],
        q4_athlete_level: 75,
        q5_sweat_level: 75,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 50,
        q8_cramp_frequency: 50,
        q9_birth_date: '1988-03-10',
        q10_weight_lbs: 155,
        q11_sex: 'male',
        q12_body_fat_category: '10_15',
        q15_region: 'mountainwest',
        q16_workout_location: 'outside',
        q17_flavor_strength: 40,
        q18_flavor_vibe: 'bright_citrusy',
        q19_caffeine_pref: 'high',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 50,
        q26_soreness: 75,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '3. CrossFit Athlete',
      description: 'Strength/CrossFit, 1 hr. Verifies: Creatine + Beta-Alanine on hydration, Creatine on protein.',
      answers: {
        'customer[first_name]': 'CrossFitTest',
        q1_sport_focus: 'strength',
        q1_strength_primary_event: 'CrossFit',
        q1_strength_type: ['crossfit'],
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['preworkout'],
        q4_athlete_level: 50,
        q5_sweat_level: 75,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 25,
        q8_cramp_frequency: 25,
        q9_birth_date: '1995-09-20',
        q10_weight_lbs: 185,
        q11_sex: 'male',
        q12_body_fat_category: '15_25',
        q15_region: 'northeast',
        q16_workout_location: 'inside',
        q17_flavor_strength: 70,
        q18_flavor_vibe: 'fruit_berry',
        q19_caffeine_pref: 'moderate',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 75,
        q26_soreness: 75,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '4. Night Owl',
      description: 'Night workout, caffeinated pref. Verifies: caffeine override to 0 on Formula A, Tryptophan + Tart Cherry boosts, NOCTURNE rec.',
      answers: {
        'customer[first_name]': 'NightOwlTest',
        q1_sport_focus: 'running',
        q1_running_primary_event: '10K',
        q1_running_type: ['road_running'],
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['drink_mix'],
        q4_athlete_level: 50,
        q5_sweat_level: 50,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 25,
        q8_cramp_frequency: 0,
        q9_birth_date: '1992-11-05',
        q10_weight_lbs: 160,
        q11_sex: 'male',
        q12_body_fat_category: '15_25',
        q15_region: 'pacific_islands',
        q16_workout_location: 'outside',
        q17_flavor_strength: 50,
        q18_flavor_vibe: 'creamy_cozy',
        q19_caffeine_pref: 'high',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['before_bed'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 100,
        q26_soreness: 25,
        q27_workout_time: 'night'
      }
    },
    {
      name: '5. Vegan Over-40',
      description: '45-year-old vegan female. Verifies: Vegan protein lock on both hydration & protein, Double Protein + CoQ10 age boosts, female electrolyte cap (65).',
      answers: {
        'customer[first_name]': 'VeganTest',
        q1_sport_focus: 'running',
        q1_running_primary_event: 'Marathon',
        q1_running_type: ['road_running'],
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['none'],
        q4_athlete_level: 50,
        q5_sweat_level: 100,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 75,
        q8_cramp_frequency: 75,
        q9_birth_date: '1981-04-22',
        q10_weight_lbs: 140,
        q11_sex: 'female',
        q12_body_fat_category: '15_25',
        q15_region: 'southeast',
        q16_workout_location: 'outside',
        q17_flavor_strength: 60,
        q18_flavor_vibe: 'fruit_berry',
        q19_caffeine_pref: 'none',
        q20_dietary_prefs: ['vegan'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 75,
        q26_soreness: 50,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '6. Salt Lick in the Southeast',
      description: 'Male, max sweat + salt lick + frequent cramps + southeast + outside. Verifies: electrolyte cap at 85, Sodium Citrate boost.',
      answers: {
        'customer[first_name]': 'SaltTest',
        q1_sport_focus: 'cycling',
        q1_cycling_primary_event: 'Road Cycling',
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['salt_pills', 'drink_mix'],
        q4_athlete_level: 50,
        q5_sweat_level: 100,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 100,
        q8_cramp_frequency: 100,
        q9_birth_date: '1990-01-15',
        q10_weight_lbs: 180,
        q11_sex: 'male',
        q12_body_fat_category: '15_25',
        q15_region: 'southeast',
        q16_workout_location: 'outside',
        q17_flavor_strength: 50,
        q18_flavor_vibe: 'bright_citrusy',
        q19_caffeine_pref: 'moderate',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 50,
        q26_soreness: 25,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '7. Elite Cyclist (3+ hr)',
      description: 'Elite athlete, 3+ hrs. Verifies: Premium Fructose Fuel 120g rec, dual formulas.',
      answers: {
        'customer[first_name]': 'EliteTest',
        q1_sport_focus: 'cycling',
        q1_cycling_primary_event: 'Gran Fondo',
        q2_workout_length: '3_plus_hours',
        q2_hunger: 66,
        q3_fueling_habits: ['gels', 'bars', 'drink_mix'],
        q4_athlete_level: 100,
        q5_sweat_level: 75,
        q6_sweat_rate_data: 'yes',
        q7_sweat_saltiness: 50,
        q8_cramp_frequency: 25,
        q9_birth_date: '1993-07-08',
        q10_weight_lbs: 165,
        q11_sex: 'male',
        q12_body_fat_category: '10_15',
        q15_region: 'southwest',
        q16_workout_location: 'outside',
        q17_flavor_strength: 30,
        q18_flavor_vibe: 'bright_citrusy',
        q19_caffeine_pref: 'high',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['post_workout'],
        q24_game_plan: 'maintain',
        q25_fruits_veggies: 75,
        q26_soreness: 50,
        q27_workout_time: 'morning'
      }
    },
    {
      name: '8. Weight Gain + Meal Replacement',
      description: 'Gain game plan, meal replacement use case. Verifies: calorie_carbs=100, Double Protein + MCT Oil + Berry Antioxidant + Ground Flaxseed.',
      answers: {
        'customer[first_name]': 'GainTest',
        q1_sport_focus: 'strength',
        q1_strength_primary_event: 'Weight Lifting',
        q1_strength_type: ['weight_lifting'],
        q2_workout_length: '1_hour',
        q3_fueling_habits: ['preworkout', 'bars'],
        q4_athlete_level: 50,
        q5_sweat_level: 50,
        q6_sweat_rate_data: 'no',
        q7_sweat_saltiness: 25,
        q8_cramp_frequency: 0,
        q9_birth_date: '1997-12-01',
        q10_weight_lbs: 200,
        q11_sex: 'male',
        q12_body_fat_category: '15_25',
        q15_region: 'midwest',
        q16_workout_location: 'inside',
        q17_flavor_strength: 80,
        q18_flavor_vibe: 'creamy_cozy',
        q19_caffeine_pref: 'moderate',
        q20_dietary_prefs: ['none'],
        q22_protein_use_cases: ['meal_replacement'],
        q24_game_plan: 'gain',
        q25_fruits_veggies: 25,
        q26_soreness: 50,
        q27_workout_time: 'morning'
      }
    }
  ];

  // ── Helpers ─────────────────────────────────────────────────────────

  function esc(str) {
    var el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }

  /** Render results into the existing quiz-results-inline DOM (mirrors quiz.js renderScoredResults) */
  function renderResults(results) {
    var container = document.getElementById('QuizResults');
    if (!container) return;

    // Heading
    var heading = container.querySelector('[data-quiz-heading]');
    if (heading) heading.textContent = results.firstName + "'s Custom Fueling Plan";

    // Results text
    var textEl = container.querySelector('[data-quiz-results-text]');
    if (textEl) {
      textEl.innerHTML = results.resultsText
        .map(function (t) { return '<p>' + esc(t) + '</p>'; })
        .join('');
    }

    function hydrationDetails(formula) {
      var items = [];
      items.push('<li>Flavor: ' + esc(formula.flavor) + ' (intensity ' + formula.flavor_slider + ')</li>');
      items.push('<li>Electrolytes: ' + formula.electrolytes_slider + '</li>');
      items.push('<li>Calories: ' + formula.calories_slider + '</li>');
      items.push('<li>Carbs: ' + formula.carbs_slider + '</li>');
      if (formula.caffeine_slider > 0) items.push('<li>Caffeine: ' + formula.caffeine_slider + '</li>');
      if (formula.protein_slider > 0) items.push('<li>Protein: ' + formula.protein_slider + '</li>');
      if (formula.aminoacids_slider > 0) items.push('<li>Amino Acids: ' + formula.aminoacids_slider + '</li>');
      if (formula.boosts && formula.boosts.length) items.push('<li>Boosts: ' + formula.boosts.length + ' added</li>');
      return items.join('');
    }

    function proteinDetails(formula) {
      var items = [];
      items.push('<li>Flavor: ' + esc(formula.flavor) + ' (intensity ' + formula.flavor_slider + ')</li>');
      items.push('<li>Protein Type: ' + esc(formula.protein_type) + '</li>');
      var ccLabel = formula.calorie_carbs_slider === 0 ? 'Low Calorie' : formula.calorie_carbs_slider === 100 ? 'High Calorie' : 'Moderate Calorie';
      items.push('<li>Calorie Level: ' + ccLabel + '</li>');
      if (formula.boosts && formula.boosts.length) items.push('<li>Boosts: ' + formula.boosts.length + ' added</li>');
      return items.join('');
    }

    function buildLink(formula, pageType) {
      var basePath = pageType === 'protein' ? '/pages/custom-protein' : '/pages/custom-hydration';
      if (window.FormulaUrlHash) {
        var hash = window.FormulaUrlHash.encode(formula);
        return hash ? basePath + '#' + hash : basePath;
      }
      return basePath;
    }

    // Hydration A
    var cardA = container.querySelector('[data-quiz-formula="hydrationA"]');
    if (cardA) {
      cardA.querySelector('[data-quiz-formula-name]').textContent = results.formulaNames.a;
      cardA.querySelector('[data-quiz-formula-details]').innerHTML = hydrationDetails(results.hydrationA);
      cardA.querySelector('[data-quiz-formula-link]').href = buildLink(results.hydrationA, 'hydration');
    }

    // Hydration B
    var cardB = container.querySelector('[data-quiz-formula="hydrationB"]');
    if (cardB) {
      if (results.hydrationB) {
        cardB.hidden = false;
        cardB.querySelector('[data-quiz-formula-name]').textContent = results.formulaNames.b;
        cardB.querySelector('[data-quiz-formula-details]').innerHTML = hydrationDetails(results.hydrationB);
        cardB.querySelector('[data-quiz-formula-link]').href = buildLink(results.hydrationB, 'hydration');
      } else {
        cardB.hidden = true;
      }
    }

    // Protein
    var cardP = container.querySelector('[data-quiz-formula="protein"]');
    if (cardP) {
      cardP.querySelector('[data-quiz-formula-name]').textContent = results.formulaNames.protein;
      cardP.querySelector('[data-quiz-formula-details]').innerHTML = proteinDetails(results.protein);
      cardP.querySelector('[data-quiz-formula-link]').href = buildLink(results.protein, 'protein');
    }

    // Recommendations
    var recsWrap = container.querySelector('[data-quiz-recs]');
    var recsList = container.querySelector('[data-quiz-recs-list]');
    if (recsWrap && recsList && results.recommendations.length) {
      recsWrap.hidden = false;
      recsList.innerHTML = results.recommendations
        .map(function (r) {
          var text = r.product;
          if (r.variant) text += ' &mdash; ' + r.variant;
          return '<li>' + esc(text) + '</li>';
        })
        .join('');
    } else if (recsWrap) {
      recsWrap.hidden = true;
    }

    container.hidden = false;
  }

  /** Build the diagnostic <details> block */
  function buildDiagnostic(fixture, results) {
    var details = document.createElement('details');
    details.className = 'quiz-test-diagnostic';
    details.style.cssText = 'margin-top:2rem;border:2px solid #f59e0b;border-radius:8px;padding:1rem;background:#fffbeb;';

    var summary = document.createElement('summary');
    summary.style.cssText = 'cursor:pointer;font-weight:700;font-size:1.1rem;color:#92400e;';
    summary.textContent = 'Test Diagnostic: ' + fixture.name;
    details.appendChild(summary);

    var desc = document.createElement('p');
    desc.style.cssText = 'margin:0.5rem 0;color:#78350f;font-style:italic;';
    desc.textContent = fixture.description;
    details.appendChild(desc);

    // Key values table
    var table = document.createElement('table');
    table.style.cssText = 'width:100%;border-collapse:collapse;margin:1rem 0;font-size:0.85rem;';

    var rows = [
      ['Electrolytes (A)', results.hydrationA.electrolytes_slider],
      ['LBW', results.lbw + ' lbs'],
      ['Caffeine A', results.hydrationA.caffeine_slider],
      ['Caffeine B', results.hydrationB ? results.hydrationB.caffeine_slider : 'N/A'],
      ['Protein Type (protein)', results.protein.protein_type],
      ['Protein Type (hydration B)', results.hydrationB ? (results.hydrationB.protein_type || 'Whey (default)') : 'N/A'],
      ['Calorie/Carbs Slider', results.protein.calorie_carbs_slider],
      ['Boosts on Hydration A', results.hydrationA.boosts.length],
      ['Boosts on Hydration B', results.hydrationB ? results.hydrationB.boosts.length : 'N/A'],
      ['Boosts on Protein', results.protein.boosts.length],
      ['Formula Count', results.hydrationB ? 3 : 2],
      ['Is 3+ Hours', results.is3Plus ? 'Yes' : 'No'],
      ['Formula A Name', results.formulaNames.a],
      ['Formula B Name', results.formulaNames.b || 'N/A'],
      ['Protein Name', results.formulaNames.protein]
    ];

    if (results.hydrationB) {
      rows.push(['Hydration B protein_slider', results.hydrationB.protein_slider]);
      rows.push(['Hydration B aminoacids_slider', results.hydrationB.aminoacids_slider]);
      rows.push(['Hydration B carbs_slider', results.hydrationB.carbs_slider]);
    }

    rows.push(['Recommendations', results.recommendations.map(function (r) {
      return r.product + (r.variant ? ' (' + r.variant + ')' : '');
    }).join(', ')]);

    var thead = '<thead><tr><th style="text-align:left;padding:4px 8px;border-bottom:2px solid #d97706;color:#92400e;">Key</th>' +
      '<th style="text-align:left;padding:4px 8px;border-bottom:2px solid #d97706;color:#92400e;">Value</th></tr></thead>';
    var tbody = '<tbody>' + rows.map(function (r) {
      return '<tr><td style="padding:4px 8px;border-bottom:1px solid #fbbf24;">' + esc(String(r[0])) +
        '</td><td style="padding:4px 8px;border-bottom:1px solid #fbbf24;font-family:monospace;">' + esc(String(r[1])) + '</td></tr>';
    }).join('') + '</tbody>';

    table.innerHTML = thead + tbody;
    details.appendChild(table);

    // Raw fixture JSON
    var fixtureDetails = document.createElement('details');
    fixtureDetails.style.cssText = 'margin-top:0.75rem;';
    var fixtureSummary = document.createElement('summary');
    fixtureSummary.style.cssText = 'cursor:pointer;font-weight:600;font-size:0.85rem;color:#92400e;';
    fixtureSummary.textContent = 'Raw Fixture (JSON)';
    fixtureDetails.appendChild(fixtureSummary);
    var fixturePre = document.createElement('pre');
    fixturePre.style.cssText = 'background:#fef3c7;padding:0.75rem;border-radius:4px;overflow-x:auto;font-size:0.75rem;max-height:300px;';
    fixturePre.textContent = JSON.stringify(fixture.answers, null, 2);
    fixtureDetails.appendChild(fixturePre);
    details.appendChild(fixtureDetails);

    // Full scored results JSON
    var resultsDetails = document.createElement('details');
    resultsDetails.style.cssText = 'margin-top:0.75rem;';
    var resultsSummary = document.createElement('summary');
    resultsSummary.style.cssText = 'cursor:pointer;font-weight:600;font-size:0.85rem;color:#92400e;';
    resultsSummary.textContent = 'Full Scored Results (JSON)';
    resultsDetails.appendChild(resultsSummary);
    var resultsPre = document.createElement('pre');
    resultsPre.style.cssText = 'background:#fef3c7;padding:0.75rem;border-radius:4px;overflow-x:auto;font-size:0.75rem;max-height:300px;';
    resultsPre.textContent = JSON.stringify(results, null, 2);
    resultsDetails.appendChild(resultsPre);
    details.appendChild(resultsDetails);

    return details;
  }

  // ── Wait for QuizEngine ─────────────────────────────────────────────

  /** Poll for window.QuizEngine (handles defer script ordering edge cases) */
  function waitForQuizEngine() {
    return new Promise(function (resolve, reject) {
      if (window.QuizEngine && window.QuizEngine.fetchAndScore) {
        return resolve();
      }
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.QuizEngine && window.QuizEngine.fetchAndScore) {
          clearInterval(interval);
          resolve();
        } else if (attempts >= 50) { // 5 seconds max
          clearInterval(interval);
          reject(new Error('QuizEngine.fetchAndScore not available after 5s'));
        }
      }, 100);
    });
  }

  // ── Runner ─────────────────────────────────────────────────────────

  function runScenario(fixture) {
    var root = document.getElementById('infinit-quiz');
    if (!root) return;

    var allPanels = Array.from(root.querySelectorAll('.quiz__panel'));
    var resultsPanel = null;
    for (var i = allPanels.length - 1; i >= 0; i--) {
      if (allPanels[i].querySelector('#QuizSummary')) {
        resultsPanel = allPanels[i];
        break;
      }
    }
    if (!resultsPanel) return;

    // Hide all panels, show results panel
    allPanels.forEach(function (p) { p.hidden = true; });
    resultsPanel.hidden = false;

    // Hide nav buttons during test
    var navEl = root.querySelector('.quiz__nav');
    if (navEl) navEl.style.display = 'none';

    // Show a full-page loading overlay
    var overlay = document.createElement('div');
    overlay.id = 'quiz-test-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;flex-direction:column;background:rgba(255,255,255,0.95);';
    overlay.innerHTML = '<div style="text-align:center;"><div class="loading-spinner" style="width:48px;height:48px;border:4px solid #e5e7eb;border-top-color:#16a34a;border-radius:50%;animation:spin 0.8s linear infinite;margin:0 auto 1rem;"></div>' +
      '<p style="font-size:1.25rem;font-weight:700;color:#78350f;">Scoring &ldquo;' + fixture.name + '&rdquo;&hellip;</p>' +
      '<p style="font-size:0.9rem;color:#a16207;">Building your custom fueling plan</p></div>' +
      '<style>@keyframes spin{to{transform:rotate(360deg)}}</style>';
    document.body.appendChild(overlay);

    var summary = document.getElementById('QuizSummary');
    var oldDiag = summary.querySelector('.quiz-test-diagnostic');
    if (oldDiag) oldDiag.remove();

    // Wait for QuizEngine to become available (defer scripts may not have run yet)
    waitForQuizEngine()
      .then(function () {
        return window.QuizEngine.fetchAndScore(fixture.answers);
      })
      .then(function (results) {
        // Save to InfinitSession and redirect to the results product page
        if (window.InfinitSession && window.InfinitSession.isInitialized()) {
          window.InfinitSession.set('quiz_results', {
            answers: fixture.answers,
            results: results,
            scored_at: new Date().toISOString()
          }).then(function () {
            window.location.href = '/products/quiz-results';
          });
        } else {
          // Fallback: render inline if session not available
          var loadEl = document.getElementById('quiz-test-loading');
          if (loadEl) loadEl.remove();
          renderResults(results);
          summary.appendChild(buildDiagnostic(fixture, results));
        }
      })
      .catch(function (err) {
        var overlayEl = document.getElementById('quiz-test-overlay');
        if (overlayEl) overlayEl.remove();
        console.error('[quiz-test-harness] Scoring failed:', err);
        alert('Scoring failed: ' + err.message);
      });
  }

  // ── UI Injection ───────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    var introPanel = document.querySelector('.quiz__panel--intro');
    if (!introPanel) return;

    var startBtn = introPanel.querySelector('[data-quiz-start]');
    if (!startBtn) return;

    // Build test panel
    var panel = document.createElement('div');
    panel.className = 'quiz-test-harness';
    panel.style.cssText = 'margin:2rem 0;padding:1.5rem;border:3px solid #f59e0b;border-radius:12px;background:#fffbeb;';

    var heading = document.createElement('h2');
    heading.style.cssText = 'margin:0 0 0.25rem 0;font-size:1.25rem;color:#92400e;';
    heading.textContent = 'Test Scenarios';
    panel.appendChild(heading);

    var subtext = document.createElement('p');
    subtext.style.cssText = 'margin:0 0 1rem 0;font-size:0.85rem;color:#a16207;';
    subtext.textContent = 'Active because ?test=yes is in the URL. Each button scores a fixture and jumps to results.';
    panel.appendChild(subtext);

    var grid = document.createElement('div');
    grid.style.cssText = 'display:grid;grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));gap:0.75rem;';

    FIXTURES.forEach(function (fixture) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.style.cssText = 'text-align:left;padding:0.75rem 1rem;border:2px solid #d97706;border-radius:8px;background:#fff;cursor:pointer;transition:background 0.15s;';

      var btnName = document.createElement('strong');
      btnName.style.cssText = 'display:block;font-size:1.1rem;color:#78350f;margin-bottom:0.25rem;';
      btnName.textContent = fixture.name;
      btn.appendChild(btnName);

      var btnDesc = document.createElement('span');
      btnDesc.style.cssText = 'display:block;font-size:0.9rem;color:#a16207;line-height:1.4;';
      btnDesc.textContent = fixture.description;
      btn.appendChild(btnDesc);

      btn.addEventListener('mouseenter', function () { btn.style.background = '#fef3c7'; });
      btn.addEventListener('mouseleave', function () { btn.style.background = '#fff'; });

      btn.addEventListener('click', function () {
        runScenario(fixture);
      });

      grid.appendChild(btn);
    });

    panel.appendChild(grid);

    // Insert before the start button
    startBtn.parentNode.insertBefore(panel, startBtn);
  });
})();
